import React, { useEffect, useState } from "react";
import AppLayout from 'layouts/AppLayout';
import axios from 'axios';
import { createGlobalStyle } from 'styled-components';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';

const GlobalStyle = createGlobalStyle`
	table {
		font-size: 13px;
	}

	input[type="number"]::-webkit-inner-spin-button,
	input[type="number"]::-webkit-outer-spin-button {
		height: auto;
	}
`;

let cancelTokenSource = null;

export default function AmountAdjustments() {
	const [rows, setRows] = useState([]);
	const [loading, setLoading] = useState(false);
	const [saving, setSaving] = useState(false);
	const [message, setMessage] = useState(null);
	const [error, setError] = useState(null);

	useEffect(() => {
		cancelTokenSource = axios.CancelToken.source();
		fetchRows();

		return function cleanup() {
			cancelTokenSource.cancel();
		};
	}, []);

	function fetchRows() {
		setLoading(true);
		setError(null);

		axios.get('/lavaderos-logs/amount-adjustments', {
			cancelToken: cancelTokenSource.token
		})
		.then((response) => {
			setRows(response.data?.map((row) => ({
				...row,
				amount: row.amount ?? 0,
			})) ?? []);
		})
		.catch((err) => {
			if (axios.isCancel(err)) return;
			setError('No se han podido cargar los ajustes');
			setRows([]);
		})
		.finally(() => setLoading(false));
	}

	function updateAmount(stationId, value) {
		setRows((prev) => prev.map((row) => {
			if (row.station_id !== stationId) return row;
			return { ...row, amount: value };
		}));
	}

	function saveAdjustments() {
		setSaving(true);
		setMessage(null);
		setError(null);

		const payload = rows.map((row) => {
			const parsed = row.amount === '' ? 0 : parseFloat(row.amount);
			return {
				station_id: row.station_id,
				amount: isNaN(parsed) ? 0 : parsed,
			};
		});

		axios.post('/lavaderos-logs/amount-adjustments', { adjustments: payload }, {
			cancelToken: cancelTokenSource.token
		})
		.then(() => {
			setMessage('Ajustes guardados');
		})
		.catch((err) => {
			if (axios.isCancel(err)) return;
			setError('No se han podido guardar los ajustes');
		})
		.finally(() => setSaving(false));
	}

	return (
		<AppLayout>
			<GlobalStyle />

			<div className="col-md-12 mb-3 d-flex align-items-center justify-content-between">
				<NavLink to="/lavaderos-to-dyngas" className="btn btn-secondary btn-sm">Volver</NavLink>
				<h4 className="mb-0">Ajustes de importes (Lavaderos 🠖 Dyngas)</h4>
				<button className="btn btn-primary btn-sm" disabled={saving || loading} onClick={saveAdjustments}>
					{saving ? 'Guardando...' : 'Guardar ajustes'}
				</button>
			</div>

			<div className="col-md-12 mb-3">
				<div className="card">
					<div className="card-body">
						<div className="mb-3 text-muted" style={{fontSize: '13px'}}>
							Introduce el ajuste numérico (puede llevar decimales) para cada estación.
						</div>

						{error && <div className="alert alert-danger py-2">{error}</div>}
						{message && <div className="alert alert-success py-2">{message}</div>}

						<div className="table-responsive">
							<table className="table table-bordered mb-0">
								<thead>
									<tr className="bg-plenoil-primary text-white">
										<th style={{width: '100px'}}>ID</th>
										<th>Nombre</th>
										<th style={{width: '160px'}}>Ajuste</th>
									</tr>
								</thead>
								<tbody>
									{loading && (
										<tr><td colSpan="3">Cargando...</td></tr>
									)}
									{!loading && rows.length === 0 && (
										<tr><td colSpan="3">No hay estaciones</td></tr>
									)}
									{!loading && rows.map((row) => (
										<tr key={row.station_id}>
											<td>{row.octan_id ?? row.station_id}</td>
											<td>{row.name}</td>
											<td>
												<input
													type="number"
													step="0.01"
													className="form-control form-control-sm"
													value={row.amount}
													onChange={(e) => updateAmount(row.station_id, e.target.value)}
												/>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</AppLayout>
	);
}
